import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  useSkeletonBoneColor,
} from '@/components/common/skeleton';

const COLUMN_WIDTHS = ['24%', '20%', '24%', '18%', '14%'] as const;
const HEADER_WIDTHS = [80, 60, 90, 70, 50] as const;
const BODY_ROW_COUNT = 8;

export const UserManagementScreenSkeleton: React.FC = () => {
  const dividerColor = useSkeletonBoneColor();

  return (
    <SkeletonGroup style={styles.container}>
      <View style={styles.headerRow}>
        {HEADER_WIDTHS.map((w, i) => (
          <View key={i} style={[styles.cell, { width: COLUMN_WIDTHS[i] }]}>
            <SkeletonBone width={w} height={12} />
          </View>
        ))}
      </View>
      <View style={[styles.divider, { backgroundColor: dividerColor }]} />
      {Array.from({ length: BODY_ROW_COUNT }).map((_, rowIdx) => (
        <View key={rowIdx} style={styles.bodyRow}>
          {COLUMN_WIDTHS.map((w, colIdx) => (
            <View key={colIdx} style={[styles.cell, { width: w }]}>
              <SkeletonBone width="80%" height={16} />
            </View>
          ))}
        </View>
      ))}
    </SkeletonGroup>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  headerRow: {
    flexDirection: 'row',
    paddingVertical: 12,
  },
  bodyRow: {
    flexDirection: 'row',
    paddingVertical: 14,
  },
  cell: {
    paddingRight: 12,
  },
  divider: {
    height: 1,
  },
});
